import palette from './palette.mjs';

const { primary, background } = palette;

export default {
  MuiButton: {
    root: {
      height: 36,
      padding: '12px 16px',
      borderRadius: 8,
      boxShadow: 'none !important',
      '&:hover': {
        boxShadow: 'none !important',
      },

      '&.Mui-disabled': {
        opacity: 0.4,
      },
      '& .MuiButton-label': {
        lineHeight: 0,
      },
      '& .MuiSvgIcon-root': {
        color: 'inherit',
      },
      '& .MuiButton-startIcon': {
        '&.MuiButton-iconSizeSmall': {
          marginLeft: '-2px',
          marginRight: 4,
        },
        '&.MuiButton-iconSizeMedium': {
          marginLeft: '-4px',
        },
        '&.MuiButton-iconSizeLarge': {
          marginLeft: '-4px',
        },
      },
      '& .MuiButton-endIcon': {
        '&.MuiButton-iconSizeSmall': {
          marginRight: '-2px',
          marginLeft: 4,
        },
        '&.MuiButton-iconSizeMedium': {
          marginRight: '-4px',
        },
        '&.MuiButton-iconSizeLarge': {
          marginRight: '-4px',
        },
      },
      '& .MuiButton-iconSizeMedium > *:first-child': {
        fontSize: '24px',
      },
      '& .MuiButton-iconSizeLarge > *:first-child': {
        fontSize: '24px',
      },
      '& .MuiButton-iconSizeSmall > *:first-child': {
        fontSize: '20px',
      },
      '& .MuiButton-iconSizeSmall > .i-icon, & .MuiButton-iconSizeSmall > .i-icon > svg': {
        width: '20px !important',
        height: '20px !important',
      },
    },
    sizeLarge: {
      height: 40,
      fontSize: 16,
      fontWeight: 500,
      padding: '12px 16px',
    },
    sizeSmall: {
      height: 32,
      fontSize: 14,
      padding: 8,
    },
    contained: {},
    containedPrimary: {
      color: background.b2,
      '&:hover': {
        backgroundColor: primary.light,
      },
      '&.Mui-disabled': {
        backgroundColor: primary.main,
        color: background.b2,
      },
    },
    textPrimary: {
      '&:hover': {
        color: primary.light,
        backgroundColor: 'rgba(3, 188, 212, 0.24)',
      },
      '&.Mui-disabled': {
        color: primary.main,
      },
    },
    text: {
      padding: '12px 16px',
      color: primary.text6,
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: background.b7,
      },
      '&.Mui-disabled': {
        color: primary.text6,
      },
    },
  },
};
